export default class PdfTemplateQrCode{
    constructor(code){
        this.id = code.id;
        this.x1 = code.x1;
        this.y1 = code.y1;
        this.width = code.width;
        this.height = code.height;
        this.template_id = code.template_id;
    }

    static getQrCodes(qrCodes){
        const codes = [];
        qrCodes.forEach(code => {
            codes.push(new PdfTemplateQrCode(code));
        });
        return codes;
    }
}